import React from 'react';
import { IconStarFilled } from '../../../app/icons/star-filled';

interface CampaignPromoBannerBadgeProps {
    children: React.ReactNode;
    style: React.CSSProperties;
}

export const CampaignPromoBannerBadge: React.FC<CampaignPromoBannerBadgeProps> = ({ children, style }) => (
    <div
        className="absolute left-[4.8rem] top-[-1.8rem] z-[2] inline-flex items-center gap-xsmall rounded-[999rem] px-[1.2rem] py-[0.7rem] text-[1.1rem] font-bold uppercase tracking-[0.06em] lg:left-[2.5rem] lg:top-[-2rem] lg:px-[1.4rem] lg:py-[0.8rem] [&_i]:h-[1.2rem] [&_i]:w-[1.2rem]"
        style={style}
    >
        <IconStarFilled /> {children}
    </div>
);
